// src/components/Transformation.jsx
import React from 'react';
import Slider from 'react-slick';
import { useTranslation } from '../context/TranslationContext';
import digitalImg from '../images/transformation/digital-transformation.jpg';
import teamImg from '../images/transformation/team-collaboration.jpg';
import aiImg from '../images/transformation/ai-interface.jpg';

export default function Transformation() {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section id="transformacion" className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 text-indigo-900">
          {t('transformation_title')}
        </h2>

        <div className="flex flex-col md:flex-row items-center bg-white rounded-lg shadow-lg overflow-hidden">
          {/* Texto */}
          <div className="w-full md:w-1/2 px-4 py-6 md:py-8">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
              {t('transformation_description')}
            </p>
          </div>

          {/* Carrusel */}
          <div className="w-full md:w-1/2 px-4 py-6 md:py-8">
            <Slider {...settings}>
              {[digitalImg, teamImg, aiImg].map((src, idx) => (
                <div key={idx} className="px-2">
                  <img
                    src={src}
                    alt={t(`transformation_image_alt_${idx}`) || 'Transformación'}
                    loading="lazy"
                    className="w-full h-56 sm:h-64 md:h-72 object-cover rounded-lg shadow-md"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
